import Vue from 'vue/dist/vue.min.js';
import store from './store';
import EventBus from './event-bus';
import axios from 'axios';
import fpodb from '../../../db.json';
import VModal from 'vue-js-modal';
import { instance } from "./modal-trigger";
import { Accordion, SelectedFiltersComponent, Checkbox, Pagination } from './filter-components';

Vue.use(VModal);

const safeString = (str) => {
    return encodeURIComponent(str);
}

const LitOrder = () => {

    let litOrder = document.querySelectorAll('.lit-order');

    const litOrderConstructor = (id) => {
        Vue.component('lit-order-template', {
            data: function() {
                return {
                    data: {
                        currentPage: 1, //current page #
                        totalPages: null, //total returns pages
                        totalResults: null, //total results
                        shownResults: null, //total shown items
                        filtersVisible: null, //are filters visible
                        filterAreaVisible: true,
                        filters: [],
                        products: [],
                        results: [],
                        emailDocs: [], //for emailing
                        savedDocs: [], //bookmarked items
                        savedDocsLabel: null, //label for saved docs,
                        savedDocsOnly: null, //is saved docs only checked?
                        isMobile: null,
                        nextActive: null,
                        prevActive: null,
                        // apiUrl: null, //for api call
                        urlParams: null, //for deeplinking in-browser
                        shareAll: false,
                        query: null, //search query,
                        store: store,
                        selectedItems: null,
                        cartContents: null,
                        isSubmitted: false,
                        modalTarget: null, //modal hash for lit order form
                        class: 'lit-order',
                        trackingType: 'document'
                    }
                }
            },
            components: {
                'filter-accordion-template': Accordion,
                'selectedFilters': SelectedFiltersComponent,
                'checkbox-item': Checkbox,
                'pagination': Pagination
            },
            computed: {
                computedIsMobile: function() {
                    return store.state.isMobile;
                },
                saved: function() {
                    return store.state.favorites.documentId;
                },
                pageRange: function() {
                    if (this.data.totalResults > 10) {
                        if (this.data.currentPage == 1) {
                            return `1-${this.data.shownResults}`;
                        } else if (this.data.currentPage == this.data.totalPages ) {
                            return `${this.data.totalResults - this.data.shownResults + 1}-${this.data.totalResults}`;
                        } else {
                            return `${(this.data.shownResults * (this.data.currentPage - 1)) + 1}-${this.data.shownResults * this.data.currentPage}`;
                        }
                    } else {
                        return this.data.shownResults;
                    }
                },
                page: function() {
                    return this.data.currentPage;
                },
                lang: function() {
                    return store.state.currentLang;
                }
            },
            watch: {
                saved: function() {
                    this.data.savedDocs = this.saved;

                    // remove saved only filter if no saved items
                    if (this.saved.length == 0) {
                        let index = this.data.filters.map((e) => {
                            return e.value
                        }).indexOf('savedDocuments');
                        if (index > -1) {
                            this.data.filters.splice(index,1);
                        }
                    }
                },
                computedIsMobile: function() {
                    this.data.isMobile = this.computedIsMobile;
                    this.data.filtersVisible = !this.computedIsMobile ? true : this.data.filtersVisible;
                },
                "data.filters": function() {
                    this.getResults(); // handle api call
                    // this.updateHistory(); // handle history record
                    // this.data.currentPage = 1; //reset page to 1
                    this.data.emailDocs = [];
                    
                    // check for if brand is selected
                    let brands = this.data.filters.filter(el => {
                        return el.type == "brand";
                    }).map(el => {
                        return el.value;
                    });

                    if (brands.length > 0) {
                        this.populateProducts(brands); 
                    } else {
                        //if not brand selected, empty the products array
                        this.data.products = []; 
                        // remove selected product filters
                        this.data.filters.filter(el => {
                            return el.type == "product"
                        }).forEach(item => {
                            this.removeFilter(this.data.class, item.value);
                        });
                    }

                    // set savedDocsOnly value
                    let savedOnly = this.data.filters.find(item => {
                        return item.type == "savedDocuments";
                    })
                    this.data.savedDocsOnly = savedOnly ? savedOnly.value : null;

                },
                page: function() {
                    if (this.data.currentPage == 1) {
                        this.data.nextActive = true;
                        this.data.prevActive = false;
                    } else if (this.data.currentPage == this.data.totalPages) {
                        this.data.nextActive = false;
                        this.data.prevActive = true;
                    } else {
                        this.data.nextActive = true;
                        this.data.prevActive = true;
                    }

                    // this.getResults();
                    // this.updateHistory();
                },
                "data.totalResults": function() {
                    this.initPages();
                },
                "data.emailDocs": function() {
                    store.commit('updateLitOrderCart', this.data.emailDocs); //store cart in store

                    // construct data string for passing selected docs to pardot
                    let itemsStr;
                    
                    this.data.emailDocs.forEach((item) => {
                        let str = `DOCUMENT ID: ${item.partNumber} | DOCUMENT NAME: ${item.name} | QUANTITY: ${item.qty} | PRE-PUNCHED: ${item.prePunched == true ? "yes" : "no"}`;
                        if (itemsStr) {
                            itemsStr = str ? `${itemsStr} || ${str}` : `${itemsStr}`;
                        } else {
                            itemsStr = str ? str : null
                        }
                    });

                    this.data.selectedItems = itemsStr;

                    // get cart 
                    // this.$nextTick(() => {
                    //     // console.log(this.$refs.cart.$el);
                    //     // console.log(this.$refs.cart.$el.outerHTML);
                    //     let cart = this.$refs.cart.$el.outerHTML;
                    //     this.data.cartContents = cart;
                    // })
                }
                
            },
            methods: {
                openCart(e) {
                    // prevent opening cart if its empty
                    if (this.data.emailDocs.length == 0) {
                        e.stopPropagation();
                    }
                },
                toggleFilters() {
                    // console.log("clicked");
                    if (this.data.isMobile) {
                        // console.log("is mobile");
                        this.data.filtersVisible = !this.data.filtersVisible;
                    }
                },
                updateFilters(el, e, type) {
                    if (el !== this.data.class) {
                        return; 
                    }
                    var type = type;
                    var value = safeString(e.currentTarget.value);
                    var label = e.currentTarget.parentNode.innerText;
                    var checked = e.currentTarget.checked;
                    this.data.currentPage = 1;
                    // console.log("type", type)
                    // console.log(e);
                    // console.log("value", safeString(e.target.value));
                    // console.log("checked",e.target.checked);

                    if (checked) {
                        if (type !== "savedDocuments") {
                            this.data.filters = [...this.data.filters, {"value": value, "type": type, "name": label}];
                        } else {
                            this.data.filters = [...this.data.filters, {"value": checked, "type": type, "name": label}];
                        }
                    } else {
                        let index = this.data.filters.map((e) => {
                            return e.value
                        }).indexOf(value);
                        // console.log("INDEX", index);
                        this.data.filters.splice(index,1);
                    }
                },
                // removes specific filter
                removeFilter(el, value, type) {
                    if (el !== this.data.class) { return; }
                    let index = this.data.filters.map((e) => {
                        return e.value
                    }).indexOf(value);
                    this.data.filters.splice(index,1);
                },
                // clears filters
                removeAll() {
                    this.data.filters = [];
                    this.data.currentPage = 1; //reset page to 1
                },  
                populateProducts(brands) {
                    // need to concat options from all selected brands and remove options when brands are unselected 
                    let brandStr = decodeURIComponent(brands.join('|'));
                    // // console.log(brandStr);
                    let apiUrl = `/api/GetDocumentProductsByBrand`;
                    // let apiUrl = "http://localhost:3003/productsByBrand"; //from json-server
                    let self = this;

                    axios.get(apiUrl, {
                            params: {
                                brand: brandStr,
                                lang: this.lang
                            }
                        })
                        .then(function(response) {
                            // console.log(response);
                            self.data.products = response.data.results;  
                        })
                        .catch(function(error) {
                            console.log(error);
                        });
                },
               
                getResults(query) {

                    // let apiUrl = "api/documents?";
                    // console.log("QUERY", query);
                    this.data.query = query === null ? null : query ? query : this.data.query;
                    this.data.currentPage = query ? 1 : this.data.currentPage;

                    // this.getUrl();
                    let baseUrl = window.documentAPIUrl;
                    let apiUrl = `${baseUrl}${baseUrl.indexOf('?') > -1 ? '' : '?'}`;
                    // let apiUrl = "http://localhost:3003/documentation"; //from json-server
                    // let apiUrlTest = "http://localhost:3003/documentationTest"; //from json-server

                    let self = this;

                    let savedDocumentsTrueParams = () => {
                        var savedOnly = this.data.filters.find(item => {
                            return item.type == "savedDocuments";
                        })
                        if (savedOnly) {
                            return true;
                        } else {
                            return false;
                        }
                    }

                    var product = [];
                    var lang = [];
                    var brand = [];
                    var docType = [];

                    this.data.filters.map((item) => {
                        switch(item.type) {
                            case "product":
                                product.push(item.value);
                                break;
                            case "lang":
                                lang.push(item.value);
                                break;
                            case "brand":
                                brand.push(item.value);
                                break;
                            case "docType":
                                docType.push(item.value);
                                break;
                            default:
                                return;
                        }
                    });

                    let productStr = decodeURIComponent(product.join('|'));
                    let langStr = decodeURIComponent(lang.join('|'));
                    let brandStr = decodeURIComponent(brand.join('|'));
                    let docTypeStr = decodeURIComponent(docType.join('|'));

                    let axiosParams = {
                        q: this.data.query ? this.data.query : null,
                        saved: (this.data.savedDocs.join('|')) == "" ? null : this.data.savedDocs.join('|').charAt(0) == "," ? this.data.savedDocs.join('|').slice(1) : this.data.savedDocs.join('|'), //@TODO make this less insane. Send NULL if empty string. Remove leading comma if present.
                        product: productStr == "" ? null : productStr,
                        language: langStr == "" ? null : langStr,
                        brand: brandStr == "" ? null : brandStr,
                        docType: docTypeStr == "" ? null : docTypeStr,
                        savedDocuments: savedDocumentsTrueParams(),
                        page: this.data.currentPage,
                    }

                    // console.log(axiosParams);
                    axios.get(apiUrl, {
                            params: {
                                ...axiosParams
                            }
                        })
                        .then(function(response) {
                            // console.log(response);
                            self.data.results = response.data.results;  
                            self.data.totalResults = response.data.totalResults;
                            self.data.shownResults = response.data.results.length;
                            //console.log(response.data);

                        })
                        .catch(function(error) {
                            console.log(error);
                        });
                },
                changePage(dir) {
                    if (dir == "prev" && this.data.currentPage !== 1) {
                        this.data.currentPage--;
                    } else if (dir == "next" && this.data.currentPage !== this.data.totalPages) {
                        this.data.currentPage++;
                    } else {
                        return;
                    }
                    EventBus.$emit('scroll-to-top', this.data.class);
                    this.getResults();
                },
                // updateEmailDocs(data) {
                //     // add or remove items to email
                //     let item = this.data.emailDocs.find(item => {
                //         return item.id == data.id;
                //     });

                //     if (!item) {
                //         this.data.emailDocs = [...this.data.emailDocs, data];
                //     } else {
                //         this.data.emailDocs.splice(this.data.emailDocs.indexOf(item),1);
                //     }
                // },
                updateEmailDocData(data) {
                    let existing = this.data.emailDocs.filter((item) => {
                        return item.id == data.id;
                    });
                    let updatedData;
                    if (existing.length > 0) {
                        updatedData = this.data.emailDocs.map((item) => {
                            if (data.id == item.id) {
                                return item = data;
                            } else {
                                return item;
                            }
                        });
                    } else {
                        updatedData = [
                            ...this.data.emailDocs,
                            data
                        ]
                    }
                    this.data.emailDocs = updatedData;
                },
                removeCartItem(id) {
                    // let index = this.data.emailDocs.map((e) => {
                    //     return e.id
                    // }).indexOf(id);
                    // if (index > -1) {
                    //     this.data.emailDocs.splice(index,1);
                    // }

                    this.data.emailDocs = this.data.emailDocs.filter((item) => {
                        return item.id !== id;
                    });
                },
                
                scrollToTop(el) {
                    if (el !== this.data.class) {return;}
                    let top = this.$el.querySelector('.lit-order__area-cards').getBoundingClientRect().top + window.scrollY -100;
                    // console.log(top);
                    setTimeout(function() {
                        window.scrollTo({
                            top: top,
                            behavior: 'smooth'
                        });
                    }, 500);
                },
                initPages() {
                    // based on total result count, divide by 10 to get total pages needed
                    // math ceil to round up
                    // set active for prev/next based on current page
                    this.data.totalPages = Math.ceil(this.data.totalResults / 10);
                    this.data.prevActive = this.data.currentPage !== 1 ? true : false;
                    this.data.nextActive = this.data.currentPage !== this.data.totalPages ? true : false;
                },
                handleSubmit(data) {
                    if (data.modalName == this.data.modalTarget) {
                        // set isSubmitted to true when form is submitted
                        this.data.isSubmitted = true;
                    }
                },
                handleClose(data) {
                    if ((data.modalName == this.data.modalTarget) && this.data.isSubmitted) {
                        this.data.emailDocs = []; //empty cart contents array on modal close (only if form is submitted)
                        this.data.isSubmitted = false; //set is submitted back to false
                    }
                },
                init() {
                    this.data.isMobile = store.state.isMobile;
                    this.data.savedDocs = store.state.favorites.documentId[0] == "" ? store.state.favorites.documentId.slice(1) : store.state.favorites.documentId;
                    this.data.filtersVisible = this.data.isMobile ? false : true; //init show/hide filters if/is mobile
                    // listen for filter updates in children
                    EventBus.$on('updateFilters', (el, e, type) => {
                        this.updateFilters(el, e, type);
                    });
                    EventBus.$on('remove-filter', (el, value, type) => {
                        this.removeFilter(el, value, type);
                    });
                    EventBus.$on('change-page-to', (el, num) => {
                        if (el !== this.data.class) {return;};
                        this.data.currentPage = num;
                        this.getResults();
                    });
                    // EventBus.$on('email-docs', (data) => {
                    //     this.updateEmailDocs(data);
                    // });
                    EventBus.$on('update-email-doc-data', (data) => {
                        this.updateEmailDocData(data);
                    });
                    EventBus.$on('internal-search', (value, type) => {
                        if (type == "documentation") {
                            this.getResults(value);
                        }
                    });
                    EventBus.$on('scroll-to-top', (el) => {
                        this.scrollToTop(el);
                    });
                    EventBus.$on('remove-cart-item', (id) => {
                        this.removeCartItem(id);
                    });
                    EventBus.$on('form-submitted', (data) => {
                        this.handleSubmit(data);
                    });
                    EventBus.$on('form-closed', (data) => {
                        this.handleClose(data);
                    });

                    // init results
                    this.data.results = window.initialDocumentationApiResults.results;
                    this.data.totalResults = window.initialDocumentationApiResults.totalResults;
                    this.data.shownResults = window.initialDocumentationApiResults.results.length;
                    // this.data.results = fpodb.documentation.results;
                    // this.data.totalResults = fpodb.documentation.totalResults;
                    // this.data.shownResults = fpodb.documentation.results.length;


                    // hide filters if less then 10 initial results
                    this.data.filterAreaVisible = parseInt(this.data.totalResults) <= 10 ? false : true;

                    // enable "share all" if 5 of less results
                    this.data.shareAll = parseInt(this.data.totalResults) <= 5 ? true : false;
                    // window.onpopstate = () => {
                    //     this.deeplink();
                    // }

                    
                    this.$nextTick(() => {
                        this.data.modalTarget = this.$refs.cartButton.getAttribute('href').substring(1);
                        // dynamic cart component container for passing to generic form modal 
                        this.data.cartContents = `<div class="lit-order__cards-content lit-order__cards-content-cart" is="cart" ref="cart" modal-target="${this.data.modalTarget}"></div>`;
                    })
                }
            },
            mounted() {
                this.init();
                this.initPages();

                // for deeplinking
                // if (window.location.search) {
                //     this.$nextTick(() => {
                //         this.deeplink();
                //     });
                // }
            }
        });

        

        Vue.component('lit-products', {
            props: ['data'],
            data: function() {
                return {
                    type: "product"
                }
            },
            components: {
                'checkbox-item': Checkbox
            },
            template: `
            <div class="lit-order__products-content">
                <checkbox-item v-for="(productItem, i) in data.products" :key=i :type="type" :label="productItem.value" :value="productItem.key" :data="data"/>
            </div>
            `,
            methods: {
            },

            mounted() {

            }
        });
        
        // results list
        Vue.component('lit-results-list', {
            props: ['data'],
            data: function() {
                return {
                    type: "document"
                }
            },
            template: `
            <div class="lit-order__cards-content">
                <lit-results-item v-for="(result, index) in data.results" :content="result" :isSelected="isSelected(result)" :qtyData="qtyData(result)" :key="result.id" :data="data" :cartVersion="false"/>
            </div>
            `,
            methods: {
                isSelected(result){
                    return this.data.emailDocs.find(i => i.id == result.id) !== undefined;
                },
                qtyData(result) {
                    let saved = this.data.emailDocs.find(i => i.id == result.id);
                    if (saved) {
                        return ({
                            qty: saved.qty,
                            prePunched: saved.prePunched 
                        });
                    } else {
                        return null;
                    }
                }
            },

            mounted() {

            }
        });

        // single results item
        Vue.component('lit-results-item', {
            props: ['data', 'content', 'isSelected', 'qtyData', 'cartVersion'],
            data: function() {
                return {
                    isChecked: this.isSelected,
                    isBookmarked: false,
                    id: null,
                    seeAll: null, //is "see all" feature enabled,
                    seeAllOpen: null,
                    seeAllLabel: null,//label
                    moreContent: null,
                    prePunched: this.qtyData ? this.qtyData.prePunched : null,
                    qty: this.qtyData ? this.qtyData.qty : null,
                    valid: true,
                    isInCart: this.cartVersion ? true : null
                }
            },
            computed: {
                saved: function() {
                    return store.state.favorites.documentId;
                },
                encodedUrl: function() {
                    return encodeURIComponent(this.content.url);
                },
                newTabLink: function() {
                    return this.content.url.replace('download=true', 'download=false');
                },
                errorMsg: function() {
                    return window.enterValidQuantityLabel;
                },
                newTabLink: function() {
                    return this.content.url ? this.content.url.replace('download=true', 'download=false') : null;
                }
            },
            watch: {
                saved: function() {
                    this.isBookmarked = this.saved.includes(this.id) ? true : false;
                },
                "cartVersion": function() {
                    if (this.cartVersion) {
                        this.isInCart = true;
                    }
                },
                "data.emailDocs": function() {
                    let match = this.data.emailDocs.filter((item) => {
                        return item.id == this.id;
                    });
                    this.isInCart = match.length > 0 ? true : false;
                    if (match.length > 0) {
                        this.qty = match[0].qty;
                        this.prePunched = match[0].prePunched;
                    } 
                    // else {
                    //     this.qty = "";
                    //     this.prePunched = null;
                    // }
                },
                "content": function() {
                    // update id when content changes
                    this.$nextTick(() => {
                        this.id = this.$refs.bookmark.dataset.documentId;
                        this.isBookmarked = this.saved.includes(`${this.id}`) ? true : false;
                    })
                },
                "seeAll": function() {
                    if (this.seeAll) {
                        this.seeAllLabel = this.seeAllOpen ? window.seeLessLabel : window.seeAllLabel;
                    }
                },
                "seeAllOpen": function() {
                    if (this.seeAll) {
                        this.seeAllLabel = this.seeAllOpen ? window.seeLessLabel : window.seeAllLabel;
                    }
                },
                "qty": function() {
                    if (!this.cartVersion) {
                        // allow empty qty value if not in cart
                        this.valid = this.qty.match(/^\d+$/) && parseInt(this.qty) >= 5 ? true : this.qty == "" ? true : false;
                    } else {
                        // if is in cart, empty values are invalid
                        this.valid = this.qty.match(/^\d+$/) && parseInt(this.qty) >= 5 ? true : false;
                    }

                    // if qty is valid, update the value
                    this.$nextTick(() => {
                        if (this.valid && this.qty !== "" && this.isInCart) {
                            EventBus.$emit('update-email-doc-data', {
                                id: this.content.id,
                                partNumber: this.content.documentId,
                                eyebrow: this.content.eyebrow,
                                details: this.content.details,
                                name: this.content.name,
                                qty: this.qty,
                                prePunched: this.prePunched,
                                url: this.content.url
                            });
                        }
                    })

                    // validate values if qty is updated in cart
                    if (this.isInCart && this.cartVersion) {
                        EventBus.$emit('check-errors');
                    }
                },
                "prePunched": function() {
                    if (this.valid && this.qty !== "" && this.isInCart) {
                        EventBus.$emit('update-email-doc-data', {
                            id: this.content.id,
                            partNumber: this.content.documentId,
                            eyebrow: this.content.eyebrow,
                            details: this.content.details,
                            name: this.content.name,
                            qty: this.qty,
                            prePunched: this.prePunched,
                            url: this.content.url
                        });
                    }
                },
                "qtyData": function() {
                    // clear qty and prepunched data if null
                    if (!this.qtyData) {
                        this.qty = "";
                        this.prePunched = null;
                    }
                }
            },
            template: `
            <div class="lit-card lit-card--checkbox">
                <div class="lit-card__wrapper">
                    <div class="lit-card__row">
                        <div class="lit-card__area lit-card__area-checkbox" :class="{hidden: cartVersion}">
                            <a class="lit-card__icon lit-card__icon-bookmark" ref="bookmark" :data-document-id="content.id" v-on:click.prevent="handleBookmark" :class="{active: isBookmarked}" data-tag-trigger="click" data-tag-meta='{"type": "app", "action": "Favorite"}'></a>
                        </div>
                        
                        <div class="lit-card__area lit-card__area-info">
                            <div class="lit-card__area lit-card__area-left">
                                <span class="lit-card__eyebrow">
                                    {{content.eyebrow}}
                                </span>
                                <a :href="newTabLink" class="lit-card__title" ref="name" target="_blank">
                                    {{content.name}}
                                </a>
                                <span class="lit-card__subtitle">
                                    <span class="lit-card__subtitle-content" ref="seeAllContent">{{content.details}}</span> <span class="lit-card__subtitle-more" v-if="seeAll && seeAllOpen">\{{moreContent}}</span> <a href="#" v-on:click.prevent="toggleSeeAll" v-if="seeAll">\{{seeAllLabel}}</a> | {{content.language}}
                                </span> 
                            </div>
                            <div class="lit-card__area lit-card__area-right">
                                <div class="lit-card__qty-container">
                                    <input class="lit-card__qty-input" v-model="qty" :class="{invalid: !valid && valid !== null}" placeholder="QTY">
                                    <a href="#" class="lit-card__button" v-on:click.prevent="addToCart" v-if="!cartVersion">Add</a>
                                    <a href="#" class="lit-card__button lit-card__button-remove" v-on:click.prevent="removeFromCart" v-if="cartVersion"><span class="lit-card__remove"></span></a>
                                </div>
                                <div class="lit-card__error" v-if="!valid">
                                    <p>{{errorMsg}}</p>
                                </div>
                                <div class="lit-card__checkbox-container checkbox">
                                    <label class="lit-card__checkbox-label checkbox__label">
                                        <input type="checkbox" class="lit-card__checkbox checkbox__input" v-model="prePunched">
                                        <span class="lit-card__checkbox-checkmark checkbox__checkmark"></span>
                                        <span class="lit-card__checkbox-text checkbox__text">Pre-punched</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>

            `,
            methods: {
                // emailDoc() {
                //     EventBus.$emit('email-docs', {
                //         "name": this.content.name, 
                //         "url": this.content.url, 
                //         "id": this.content.id, 
                //         "qty": this.qty,
                //         "prePunched": this.prePunched,
                //         "eyebrow": this.content.eyebrow,
                //         "details": this.content.details
                //     });
                // },
                handleBookmark() {
                    store.commit('updateFavorites', {
                        id: this.id,
                        type: "documentId",
                        action: this.isBookmarked ? "remove" : "add"
                    });
                    store.dispatch('checkFavorites');
                },
                toggleSeeAll() {
                    this.seeAllOpen = !this.seeAllOpen;
                },
                initSeeAll() {
                    if (this.$refs.seeAllContent) {
                        let details = this.$refs.seeAllContent.innerHTML.split(',');
                        this.seeAll = details.length > 3 ? true : false;

                        let truncatedDetails = details.slice(0,3).join();
                        let moreDetails = details.slice(3).join();

                        this.moreContent = moreDetails;
                        this.$refs.seeAllContent.innerHTML = `${truncatedDetails}${moreDetails == "" ? '' : ','}`;
                    }
                },
                addToCart() {
                    if (!this.qty) {
                        this.valid = false;
                    } else if (parseInt(this.qty) < 5) {
                        this.valid = false;
                    } else {
                        let data = {
                            id: this.content.id,
                            partNumber: this.content.documentId,
                            eyebrow: this.content.eyebrow,
                            details: this.content.details,
                            name: this.content.name,
                            qty: this.qty,
                            prePunched: this.prePunched,
                            url: this.content.url
                        }
                        EventBus.$emit('update-email-doc-data', data);
                    }
                },
                removeFromCart() {
                    EventBus.$emit('remove-cart-item', this.id);
                }
            },
            mounted() {
                this.id = this.$refs.bookmark.dataset.documentId;
                // console.log("saved",this.saved);
                this.isBookmarked = this.saved.includes(`${this.id}`) ? true : false;
                this.initSeeAll();

                // if item is explicitly removed from cart, clear its input values
                EventBus.$on('remove-cart-item', (id) => {
                    if (id == this.id) {
                        this.qty = "";
                        this.prePunched = null;
                    }
                });
            }
        });

        // cart
        Vue.component('cart', {
            props: ['modalTarget'],
            data: function() {
                return {
                    hasErrors: null,
                    cartHash: null,
                    isSubmitted: false
                }
            },
            computed: {
                cartContent: function() {
                    return store.state.litOrderCart;
                },
                errorMsg: function() {
                    return window.enterValidQuantityLabel;
                }
            },
            watch: {
                hasErrors: function() {
                    if (this.hasErrors) {
                        this.$el.parentNode.classList.add('hasErrors');
                    } else {
                        this.$el.parentNode.classList.remove('hasErrors');
                    }
                },
                cartContent: function() {
                    if (this.cartContent.length == 0) {
                        instance.closeModal(this.cartHash);
                    }
                },
                // for showing/hiding cart module. hide if submitted.
                isSubmitted: function() {
                    this.$el.style.display = this.isSubmitted ? 'none' : 'block';
                }
            },
            template: `
            <div>
                <div>
                    <lit-results-item v-for="(result, index) in cartContent" :content="result" :key="result.id" :cartVersion="true" :qtyData="qtyData(result)" />
                </div>
                <p class="lit-card__error" v-if="hasErrors">{{errorMsg}}<p/>
            </div>`,
            methods: {
                qtyData(result) {
                    let saved = this.cartContent.find(i => i.id == result.id);
                    if (saved) {
                        return ({
                            qty: saved.qty,
                            prePunched: saved.prePunched 
                        });
                    } else {
                        return null;
                    }
                },
                checkErrors() {
                    // console.log("checking");
                    this.$nextTick(() => {
                        let invalidEntry = this.$el.querySelector('.lit-card__qty-input.invalid');
                        this.hasErrors = invalidEntry ? true : false;
                        //console.log(invalidEntry);
                    })
                },
                getHash() {
                    this.cartHash = this.$el.closest('.bmi-modal__wrapper') ? this.$el.closest('.bmi-modal__wrapper').getAttribute('name') : null;
                },
                handleSubmit(data) {
                    if (data.modalName == this.modalTarget) {
                        this.isSubmitted = true;
                    }
                },
                handleClose(data) {
                    if ((data.modalName == this.modalTarget) && this.isSubmitted) {
                       this.isSubmitted = false; //set is submitted back to false
                    }
                },
                init() {
                    EventBus.$on('form-submitted', (data) => {
                        this.handleSubmit(data);
                    });
                    EventBus.$on('form-closed', (data) => {
                        this.handleClose(data);
                    });
                }
            },
            mounted() {
                EventBus.$on('check-errors', () => {
                    this.checkErrors();
                });
                this.getHash(); 
                this.init();
            }
        });

        new Vue({
            el: `.lit-order-${id}`,
            store: store
        }).$mount(`.lit-order-${id}`, true);
    }

    if (litOrder.length > 0) {
        litOrder.forEach((item, index) => {
            item.classList.add(`lit-order-${index}`);
            litOrderConstructor(index);
        })
    }

    // window.enterValidQuantityLabel = "error test";

}

export default LitOrder;
